import { render, staticRenderFns } from "./ColorSwitch.vue?vue&type=template&id=72fd168c&"
import script from "./ColorSwitch.vue?vue&type=script&lang=js&"
export * from "./ColorSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports